import { default as _indexCVC9eo4FTjMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/_index.vue?macro=true";
import { default as _91_46_46_46cms_93CTNYe3eARdMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/[...cms].vue?macro=true";
import { default as indexc5SHvT5T1CMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/cart/index.vue?macro=true";
import { default as indexC7DGq9XiTlMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/cart/success/index.vue?macro=true";
import { default as _91_46_46_46slug_930H4FNHhx9iMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/catalog/[...slug].vue?macro=true";
import { default as indexR6eoVvOF0vMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93b2X4ezidolMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/collection/[...slug].vue?macro=true";
import { default as indexNorcIlG7ddMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/email/index.vue?macro=true";
import { default as indexatJkCNbN2pMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/kontakty/index.vue?macro=true";
import { default as _91_46_46_46slug_93L9CpXk0JO0Meta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/product/[...slug].vue?macro=true";
import { default as indexSzPpvvVDNRMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/search/index.vue?macro=true";
import { default as indexpx8KcSZmepMeta } from "/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _indexCVC9eo4FTjMeta?.name ?? "_index",
    path: _indexCVC9eo4FTjMeta?.path ?? "/_index",
    meta: _indexCVC9eo4FTjMeta || {},
    alias: _indexCVC9eo4FTjMeta?.alias || [],
    redirect: _indexCVC9eo4FTjMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/_index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46cms_93CTNYe3eARdMeta?.name ?? "cms",
    path: _91_46_46_46cms_93CTNYe3eARdMeta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93CTNYe3eARdMeta || {},
    alias: _91_46_46_46cms_93CTNYe3eARdMeta?.alias || [],
    redirect: _91_46_46_46cms_93CTNYe3eARdMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: indexc5SHvT5T1CMeta?.name ?? "cart",
    path: indexc5SHvT5T1CMeta?.path ?? "/cart",
    meta: indexc5SHvT5T1CMeta || {},
    alias: indexc5SHvT5T1CMeta?.alias || [],
    redirect: indexc5SHvT5T1CMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: indexC7DGq9XiTlMeta?.name ?? "cart-success",
    path: indexC7DGq9XiTlMeta?.path ?? "/cart/success",
    meta: indexC7DGq9XiTlMeta || {},
    alias: indexC7DGq9XiTlMeta?.alias || [],
    redirect: indexC7DGq9XiTlMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/cart/success/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_930H4FNHhx9iMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_930H4FNHhx9iMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_930H4FNHhx9iMeta || {},
    alias: _91_46_46_46slug_930H4FNHhx9iMeta?.alias || [],
    redirect: _91_46_46_46slug_930H4FNHhx9iMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexR6eoVvOF0vMeta?.name ?? "catalog",
    path: indexR6eoVvOF0vMeta?.path ?? "/catalog",
    meta: indexR6eoVvOF0vMeta || {},
    alias: indexR6eoVvOF0vMeta?.alias || [],
    redirect: indexR6eoVvOF0vMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93b2X4ezidolMeta?.name ?? "collection-slug",
    path: _91_46_46_46slug_93b2X4ezidolMeta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_93b2X4ezidolMeta || {},
    alias: _91_46_46_46slug_93b2X4ezidolMeta?.alias || [],
    redirect: _91_46_46_46slug_93b2X4ezidolMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexNorcIlG7ddMeta?.name ?? "email",
    path: indexNorcIlG7ddMeta?.path ?? "/email",
    meta: indexNorcIlG7ddMeta || {},
    alias: indexNorcIlG7ddMeta?.alias || [],
    redirect: indexNorcIlG7ddMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/email/index.vue").then(m => m.default || m)
  },
  {
    name: indexatJkCNbN2pMeta?.name ?? "kontakty",
    path: indexatJkCNbN2pMeta?.path ?? "/kontakty",
    meta: indexatJkCNbN2pMeta || {},
    alias: indexatJkCNbN2pMeta?.alias || [],
    redirect: indexatJkCNbN2pMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/kontakty/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93L9CpXk0JO0Meta?.name ?? "product-slug",
    path: _91_46_46_46slug_93L9CpXk0JO0Meta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_93L9CpXk0JO0Meta || {},
    alias: _91_46_46_46slug_93L9CpXk0JO0Meta?.alias || [],
    redirect: _91_46_46_46slug_93L9CpXk0JO0Meta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexSzPpvvVDNRMeta?.name ?? "search",
    path: indexSzPpvvVDNRMeta?.path ?? "/search",
    meta: indexSzPpvvVDNRMeta || {},
    alias: indexSzPpvvVDNRMeta?.alias || [],
    redirect: indexSzPpvvVDNRMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/search/index.vue").then(m => m.default || m)
  },
  {
    name: indexpx8KcSZmepMeta?.name ?? "wishlist",
    path: indexpx8KcSZmepMeta?.path ?? "/wishlist",
    meta: indexpx8KcSZmepMeta || {},
    alias: indexpx8KcSZmepMeta?.alias || [],
    redirect: indexpx8KcSZmepMeta?.redirect,
    component: () => import("/var/www/cilek-kids.ru/frontend/cilek-front-20250530140300/pages/wishlist/index.vue").then(m => m.default || m)
  }
]